<div class="formContainer" [ngClass]="{hasLoader: isLoading}">
  <ul *ngIf="!error; else errorMsg">
    <div [ngSwitch]="selectedForm">
      <div *ngSwitchCase="getPaidForms.PERSONAL_INFORMATION">
        <vc-personal-information
          [userIsB2C]="userIsB2C"
          [isWebView]="isWebView"
          (customerCreated)="onCustomerCreated($event)"
        ></vc-personal-information>
      </div>
      <div *ngSwitchCase="getPaidForms.TRANSFERT_METHOD">
        <div *ngIf="showTransferMethodCountryForm" class="transferMethodCountry">
          <div class="transferMethodCountry__title vc-text-l" i18n="@@GET_PAID.TRANSFER_METHOD_COUNTRY.TITLE">
            Please select the country where you want to get paid
          </div>
          <div class="vc-formUnit vc-formUnit--select">
            <select
              name="country"
              class="vc-inputText transferMethodCountry__select"
              [(ngModel)]="transferMethodCountryCode"
            >
              <option value="" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.PLACEHOLDER.COUNTRY">Select a country</option>
              <option *ngFor="let c of countryList" [value]="c.isoCode">
                {{ c.name }}
              </option>
            </select>
            <label class="vc-inputText-label" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.COUNTRY">country </label>
          </div>

          <div
            class="transferMethodCountry__informationMessage vc-text-m"
            *ngIf="showInformationMessageForCountries"
            i18n="@@GET_PAID.EXTRA_FIELD_COUNTRIES_INFORMATION_MESSAGE"
          >
            In this form, please enter your information as it appears on your bank account statements, and in local
            characters.
          </div>
          <div class="transferMethodCountry__button">
            <button
              class="vc-btn vc-btn--primary vc-btn--large vc-btn--full vc-btn--notfull--md-up"
              i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.SUBMIT_BUTTON"
              [ngClass]="{disabled: !transferMethodCountryCode}"
              (click)="onTransferMethodCountrySubmit()"
            >
              Next
            </button>
          </div>
        </div>
        <div id="TransferMethodUI" class="transfer-method-ui"></div>
      </div>
      <div *ngSwitchCase="getPaidForms.VERIFICATION">
        <div class="kycChooseSteps d-md-none">
          <div class="kycChooseSteps__button" (click)="showKycSteps = !showKycSteps">
            <span>
              Choose steps
            </span>
            <div class="kycChooseSteps__icon">
              <vc-sprite-icons
                [name]="'arrow-head-' + (showKycSteps ? 'up' : 'down')"
                class="kycChooseStepsContainer__button__icon"
              ></vc-sprite-icons>
            </div>
          </div>
        </div>
        <div id="VerificationUI" class="verification-ui" [ngClass]="{showSteps: showKycSteps}"></div>
      </div>
    </div>
  </ul>
  <ng-template #errorMsg>
    <vc-get-paid-error></vc-get-paid-error>
  </ng-template>
</div>
